<template>
  <div
    class="PropertyProjectInformationDetailList vheight container-boot PublicInformationDetail"
  >
    <el-tabs type="border-card">
      <el-tab-pane label="业主大会和业委会信息">
        <div
          class="basInfo-table"
          v-if="!isNotShowData"
          v-loading="detailLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              统一社会信用代码
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Tyshxydm || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业主大会名称
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Yzdhmc || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业主大会地址
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Yzdhdz ? ProjectDetail.Yzdhdz : '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业主大会负责人
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Yzdhfzr || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业主大会统一代码证有效期
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Yzdhdmzyxq || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              物业项目名称
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ projectItems.EaAreaName || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">项目所属区</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ projectItems.PropertyCantonName || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">业委会名称</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Yzwyhmc ? ProjectDetail.Yzwyhmc : '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">业委会届别</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Yzdhjb ? ProjectDetail.Yzdhjb : '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业委会任期起止时间
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Ywhrqjzsj ? ProjectDetail.Ywhrqjzsj : '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业委会运作状态
            </div>
            <div class="col-define col-xs-4 col-md-4">
              <template>
                <span v-if="ProjectDetail.RunningState == 1">正常运作</span>
                <span v-else-if="ProjectDetail.RunningState == 2"
                  >非正常运作（已过期）</span
                >
                <span v-else-if="ProjectDetail.RunningState == 3"
                  >非正常运作（已解散）</span
                >
                <span v-else>--</span>
              </template>
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业委会执行秘书
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.Ywhzxms || '--' }}
            </div>
          </div>
        </div>
        <div class="no-data" v-else>暂无业主大会和业委会信息</div>
      </el-tab-pane>
      <el-tab-pane label="业委会成员列表">
        <div class="basInfo-table">
          <el-table
            :data="OwnerCommitteeMember"
            style="width: 100%"
            v-loading="loading"
            element-loading-text="数据正在加载中，请稍候"
          >
            <!-- 加载的时候不要显示暂无数据 -->
            <template slot="empty">
              <span v-if="loading"></span>
              <span v-else>暂无数据</span>
            </template>
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column
              prop="OwnerName"
              label="姓名"
              width="180"
            ></el-table-column>
            <el-table-column label="性别" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.OwnerSex == 1"> 男 </span>
                <span v-else> 女 </span>
              </template>
            </el-table-column>
            <el-table-column prop="OwnerNationLabel" label="民族" width="180">
              <template slot-scope="scope">
                {{
                  scope.row.OwnerNationLabel ? scope.row.OwnerNationLabel : '--'
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="OwnerTeamMemberRoleName"
              label="职务"
            ></el-table-column>
          </el-table>
          <div class="footer ub ub-pe">
            <div class="page">
              <ps-page :page="page" @getData="getComplains()"></ps-page>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="PublicInformationDetail-footer"></div>
  </div>
</template>

<script>
import { OpenControllerSvr } from '@/service/OpenControllerSvr/OpenControllerSvr.js';
import { PropertyProjectControllerSvr } from '@/service/PropertyProjectControllerSvr/PropertyProjectControllerSvr.js';
import { BuildUnitInfoControllerSvr } from '@/service/BuildUnitInfoControllerSvr/BuildUnitInfoControllerSvr.js';
import { Page } from '@/models/page';
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  name: 'GeneralMeetingOfProprietorsDetailList',
  metaInfo: {
    title: '业主大会和业委会查询',
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
      },
      { name: 'SiteName', content: '深圳市住房和建设局网站' },
      { name: 'SiteDomain', content: 'zjj.sz.gov.cn' },
      { name: 'SiteIDCode', content: '4403000005' },
      { name: 'ColumnName', content: '物业管理政策专题' },
      {
        name: 'ColumnDescription',
        content: '该栏目公布物业管理政策专栏的信息。',
      },
      { name: 'ColumnKeywords', content: '物业管理政策专栏' },
      { name: 'ColumnType', content: '其他' },
    ],
  },
  data() {
    return {
      orgCode: '',
      eaAreaCode: '',
      OwnerTeamCode: '',
      keyID: '',
      ProjectDetail: {},
      projectItems: {},
      OwnerCommittee: {},
      OwnerCommitteeMember: [],
      BuildUnit: '',
      PertyMgeInfo: '',
      startIndex: 0,
      maxSize: 20,
      page: new Page(),
      isNotShowData: false,
      loading: false,
      detailLoading: false,
    };
  },
  computed: {
    ...mapState(['token', 'tabsRouter']),
  },
  created() {
    this.OpenControllerSvr = new OpenControllerSvr();
    this.BuildUnitInfoControllerSvr = new BuildUnitInfoControllerSvr();
    this.PropertyProjectControllerSvr = new PropertyProjectControllerSvr();
  },
  mounted() {
    this.orgCode = this.$route.query.orgCode;
    // this.unifiedSocialCreditCode = this.$route.query.unifiedSocialCreditCode;
    this.OwnerTeamCode = this.$route.query.ownerTeamCode || '';
    this.keyID = this.$route.query.keyID;
    this.getProjectDetails();
    this.getOwnerCommittee();
    this.getOwnerCommitteeMember();
    // this.getData(); PropertyProjectInformationDetailList
  },
  methods: {
    ...mapActions({
      DeleTabsRouter: 'DeleTabsRouter',
    }),
    //获取物业企业
    getproPertyMgeInfo() {
      this.PropertyMgeInfoControllerSvr.GetproPertyMgeInfo(
        this.token,
        this.orgCode
      )
        .then(
          (res) => {
            this.PertyMgeInfo = res.OrgName;
          },
          (err) => {
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {});
    },
    // 获取项目详情
    getProjectDetails() {
      this.detailLoading = true;
      this.OpenControllerSvr.getZjjOwnerTeamVoByorgCode(this.orgCode)
        .then(
          (res) => {
            if (res) {
              this.detailLoading = false;
              this.ProjectDetail = res;
              this.eaAreaCode = res.EaAreaCode;

              this.PropertyProjectControllerSvr.GetProjectDetails(
                this.eaAreaCode
              )
                .then(
                  (res) => {
                    if (res) {
                      this.projectItems = res;
                    }
                  },
                  (err) => {
                    this.$message({
                      message: err.Msg,
                      type: 'error',
                    });
                  }
                )
                .catch(() => {});
            } else {
              this.isNotShowData = true;
            }
          },
          (err) => {
            this.detailLoading = false;
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.detailLoading = false;
        });
    },
    // 业主委员会
    getOwnerCommittee() {
      this.OpenControllerSvr.getZjjOwnerTeamVoByEaAreaCode(this.eaAreaCode)
        .then(
          (res) => {
            this.OwnerCommittee = res;
            this.OwnerCommittee.ContactTel =
              this.OwnerCommittee.ContactTel.substr(0, 3) +
              '****' +
              this.OwnerCommittee.ContactTel.substr(7);
          },
          (err) => {
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {});
    },
    // 业委会成员信息
    getOwnerCommitteeMember() {
      if (!this.OwnerTeamCode) {
        return;
      }
      this.loading = true;
      this.OpenControllerSvr.getOwnerCommitteeMemberListForOut(
        this.OwnerTeamCode,
        '',
        '',
        '',
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum,
        true
      )
        .then(
          (res) => {
            this.loading = false;
            this.OwnerCommitteeMember = res._Items;
            this.page.getCurrtNum = res.TotalCount;
          },
          (err) => {
            this.loading = false;
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.PublicInformationDetail {
  height: 100%;
  width: 100%;
  .basInfo-table {
    overflow: auto;
    .row {
      margin-right: 0;
      margin-left: 0;
      @media screen and (max-width: 992px) {
        flex-wrap: wrap !important;
      }
      .col-define {
        font-size: 14px;
        line-height: 42px;
        min-width: 150px;
        overflow: hidden;
        color: #666;
        border-bottom: 1px solid #e2e2e2;
        .col-chld {
          display: inline-block;
          width: 25%;
          & > div:nth-child(1) {
            display: inline-block;
            width: 30%;
            vertical-align: top;
          }
          & > div:nth-child(2) {
            display: inline-block;
            width: 70%;
          }
        }
      }
      .col-define:nth-child(2n) {
        flex: 1;
        border-right: 1px dotted #e2e2e2;
        padding-left: 24px;
      }

      .col-define:nth-child(2n-1) {
        text-align: right;
      }

      .col-tips {
        border-right: 1px dotted #e2e2e2;
      }
    }
  }
  .PublicInformationDetail-footer {
    text-align: right;
    margin: 20px;
  }
}
.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 530px;
}
.InformationDetailPropertyEnterprisesList {
  width: 100%;
  box-sizing: border-box;
  .function {
    min-width: 400px;
  }
  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100% - 30px);
    }
  }
  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;
    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;
      .delete {
        margin-left: 20px;
      }
    }
  }
}
</style>
